import Text from '~/core/Text'

const Divider = () => (
    <Text
        color="blackAlpha15"
        fontSize="14px"
        style={{ margin: '0 10px 0 10px' }}
    >
        |
    </Text>
)

export default Divider
